import Vue from 'vue'
import VueRouter from 'vue-router'

// Commons
import Login from '../views/Login.vue'
import RecuperarSenha from '../views/RecuperarSenha'
import Home from '../views/Home.vue'
import Chamados from '../views/Chamados.vue'
import Contatos from '../views/Contatos.vue'
import Configs from '../views/Configs.vue'
import Disparos from '../views/Disparos.vue'
import Block from '../views/Block.vue'
import Version from '../views/Version.vue'
import Upgrade from '../views/Upgrade.vue'
import Empresas from '../views/Empresas.vue'
import DisparosOld from "@/views/DisparosOld";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/recuperar',
    name: 'RecuperarSenha',
    component: RecuperarSenha
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/chamados',
    name: 'Chamados',
    component: Chamados
  },
  {
    path: '/contatos',
    name: 'Contatos',
    component: Contatos
  },
  {
    path: '/disparos-old',
    name: 'DisparosOld',
    component: DisparosOld
  },
  {
    path: '/disparos',
    name: 'Disparos',
    component: Disparos
  },
  {
    path: '/configs',
    name: 'Configs',
    component: Configs
  },
  {
    path: '/block',
    name: 'Block',
    component: Block
  },
  {
    path: '/versao',
    name: 'Version',
    component: Version
  },
  {
    path: '/upgrade',
    name: 'Upgrade',
    component: Upgrade
  },
  {
    path: '/empresas',
    name: 'Empresas',
    component: Empresas
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router
